import Dialog from "@components/dialog/Dialog";
import { withConfirmationDialog } from "@components/dialog/withConfirmationDialog";
import { EntitySetName, IBankTransactionEntity } from "@odata/GeneratedEntityTypes";
import { DocumentTypeCode } from "@odata/GeneratedEnums";
import {
    handleBeforeSave,
    insertBankStatementMetadataToEntity
} from "@pages/banks/bankTransactions/BankTransactions.utils";
import {
    BankTransactionsFormViewForExtend,
    BASE_ALLOWED_NAVIGATIONS
} from "@pages/banks/bankTransactions/BankTransactionsFormView";
import { getLoanPairStatementDefinition } from "@pages/banks/bankTransactions/BankTransactionStatementPairDef";
import DialogPage from "@pages/DialogPage";
import { LoanTransactionStatementPairTableView } from "@pages/loans/transactions/LoanTransactionStatementPairTableView";
import { cloneDeep } from "lodash";
import React from "react";

import { withPermissionContext } from "../../../contexts/permissionContext/withPermissionContext";
import { PageViewMode } from "../../../enums";
import { IEntity } from "../../../odata/BindingContext";

class LoanTransactionsFormView extends BankTransactionsFormViewForExtend {
    ALLOWED_NAVIGATIONS = BASE_ALLOWED_NAVIGATIONS;

    documentTypeCode = DocumentTypeCode.LoanTransaction;

    handlePreSave = () => {
        this.save({
            queryParams: {
                postInvoice: true
            }
        });
    };

    getReadOnlyNavButtonText = () => {
        return this.props.storage.t("Loans:Form.OpenFormTransaction");
    };

    updateAccounts = async (): Promise<void> => {
        await this.context.updateLoanAccounts();
    };

    renderAssignStatementDialog = () => {
        return (
            <>
                {this.props.storage.getCustomData().statementPairedDialogOpened &&
                    <Dialog
                        isEditableWindow={true}
                        onConfirm={null}
                        onClose={this.handleClosePairStatementPairing}>
                        <DialogPage
                            onAfterSave={this.handleStatementPairingDialogAfterSave}
                            pageViewMode={PageViewMode.FormReadOnly}
                            rootStorage={this.props.storage}
                            tableView={LoanTransactionStatementPairTableView}
                            getDef={getLoanPairStatementDefinition}/>
                    </Dialog>
                }
            </>
        );
    };


    prepareDataForSave = async (data: IEntity, isDraft?: boolean): Promise<IBankTransactionEntity> => {
        const entity = cloneDeep(data);
        const { storage } = this.props;
        handleBeforeSave(storage, entity);
        insertBankStatementMetadataToEntity(storage, entity, EntitySetName.LoanStatements);

        return entity;
    };
}

export default withConfirmationDialog(withPermissionContext(LoanTransactionsFormView));